import withHelmet from '../HOC/withHelmet';
import HomePage from '../components/home';

export default withHelmet(
  HomePage,
  "Children's Books Online, Free Kids Books, Read Books to Children - Readeo.com",
);
